function Toaster({ toasts, delToast }) {
    return (
        <div key="toaster" style="position: fixed; top: 5px; right: 3px;overflow: hidden; z-index: 10000">
            {
                toasts.map((toast, i) => {
                    return (
                        <div key={i} class={"toast align-items-center show bg-" + toast.type} style="opacity:1" role="alert" aria-live="assertive" aria-atomic="true">
                            <div class="d-flex">
                                <div class="toast-body text-white">
                                    {toast.text}
                                </div>
                                <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close" onClick={() => delToast(toast.id)} />
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default Toaster;